<script setup>
</script>

<template>
<div class="mc-page">

    <!-- Hero -->
    <div class="mc-hero">
        <div class="mc-hero-overlay"></div>
        <div class="mc-hero-content">
            <img src="/assets/imgs/ncz/Wide_Logo.png" class="mc-wide-logo" alt="NightCrafterz" />
            <p class="mc-subtitle">The NightRiderz Minecraft Server</p>
            <p class="mc-subtitle2">Modded Survival — enhanced experience with a curated modpack</p>
            <div class="mc-badges">
                <span class="mc-badge mc-badge-green">▶ Build Phase v1.0</span>
                <span class="mc-badge mc-badge-blue">Fabric 1.21.8</span>
                <span class="mc-badge mc-badge-gray">🇪🇺 Paris</span>
            </div>
        </div>
    </div>

    <div class="mc-body">

        <!-- Server info -->
        <div class="mc-card">
            <div class="mc-card-icon-row">
                <img src="/assets/imgs/ncz/Square_Logo_Block.png" class="mc-card-logo" alt="NCZ" />
                <h2 class="mc-card-title">Server Information</h2>
            </div>
            <div class="mc-info-grid">
                <div class="mc-info-row">
                    <span class="mc-info-label">Server IP</span>
                    <span class="mc-info-value ip-value">nightcrafterz.nightriderz.world</span>
                </div>
                <div class="mc-info-row">
                    <span class="mc-info-label">Version</span>
                    <span class="mc-info-value">Fabric 1.21.8 — Loader 0.18.3</span>
                </div>
                <div class="mc-info-row">
                    <span class="mc-info-label">Status</span>
                    <span class="mc-info-value mc-green">▶ Build Phase — v1.0</span>
                </div>
                <div class="mc-info-row">
                    <span class="mc-info-label">Datacenter</span>
                    <span class="mc-info-value">Europe (Paris)</span>
                </div>
            </div>
        </div>

        <!-- Installation -->
        <div class="mc-card">
            <h2 class="mc-card-title">How to Join</h2>
            <p class="mc-note">Installation via <span class="mc-yellow">CurseForge</span> is required.</p>
            <div class="mc-steps">
                <div class="mc-step">
                    <div class="mc-slot">1</div>
                    <div class="mc-step-text">Download and open <span class="mc-yellow">CurseForge</span></div>
                </div>
                <div class="mc-step">
                    <div class="mc-slot">2</div>
                    <div class="mc-step-text">Import the <span class="mc-yellow">ncz 1.0</span> modpack ZIP — latest link always in Discord</div>
                </div>
                <div class="mc-step">
                    <div class="mc-slot">3</div>
                    <div class="mc-step-text">Click <span class="mc-green">Play</span> on the modpack — you're in!</div>
                </div>
                <div class="mc-step">
                    <div class="mc-slot">4</div>
                    <div class="mc-step-text">Go to <span class="mc-yellow">Multiplayer</span> and connect:<br>
                        <span class="mc-ip">nightcrafterz.nightriderz.world</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- Discord -->
        <div class="mc-card mc-center">
            <h2 class="mc-card-title">Community</h2>
            <p class="mc-note">Get the modpack ZIP, updates and support on our dedicated Discord.</p>
            <a href="https://discord.gg/5T5aXwRSBc" target="_blank" class="mc-discord-btn">
                <v-icon style="margin-right:8px;font-size:18px">mdi-discord</v-icon>
                Join NightCrafterz Discord
            </a>
        </div>

    </div>
</div>
</template>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Press+Start+2P&display=swap');

/* ══════════════════════════════════════
   PAGE — fond dirt pixelisé
══════════════════════════════════════ */
.mc-page {
    display: flex;
    flex-direction: column;
    background-color: #6b4226;
    background-image: url('https://minecraft.wiki/images/Dirt_JE2_BE2.png');
    background-size: 64px 64px;
    image-rendering: pixelated;
    color: #fff;
    font-family: 'Press Start 2P', monospace;
}

/* ══════════════════════════════════════
   HERO
══════════════════════════════════════ */
.mc-hero {
    position: relative;
    min-height: 300px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    background: url('/assets/imgs/ncz/header.png') center center / cover no-repeat;
    /* bande herbe en bas */
    border-bottom: 8px solid #5a9e3a;
    box-shadow: 0 8px 0 #3d6e27, 0 16px 0 #6b4226;
    margin-bottom: 16px;
}

.mc-hero-overlay {
    position: absolute;
    inset: 0;
    background: linear-gradient(to bottom, rgba(0,0,0,0.2) 0%, rgba(0,0,0,0.65) 100%);
}

.mc-hero-content {
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 14px;
    padding: 60px 24px 50px;
    text-align: center;
}

.mc-wide-logo {
    max-width: 420px;
    width: 85%;
    image-rendering: pixelated;
    filter: drop-shadow(4px 4px 0 rgba(0,0,0,0.9));
}

.mc-subtitle {
    font-size: 0.9rem;
    color: rgba(255,255,255,0.75);
    margin: 0;
    letter-spacing: 2px;
    text-shadow: 2px 2px 0 #000;
    text-transform: uppercase;
}

.mc-subtitle2 {
    font-size: 0.9rem;
    color: #55ff55;
    text-shadow: 2px 2px 0 #003f00;
    margin: -4px 0 0;
    letter-spacing: 1px;
}

.mc-badges {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
    justify-content: center;
}

.mc-badge {
    font-size: 0.75rem;
    padding: 4px 10px;
    letter-spacing: 1px;
    text-shadow: 1px 1px 0 #000;
    /* border style inventaire MC */
    box-shadow: inset -1px -2px 0 rgba(0,0,0,0.5), inset 1px 1px 0 rgba(255,255,255,0.3);
}

.mc-badge-green  { background: #1a5c1a; color: #55ff55; }
.mc-badge-blue   { background: #1a3a5c; color: #55aaff; }
.mc-badge-gray   { background: #3f3f3f; color: #d4d4d4; }

/* ══════════════════════════════════════
   BODY
══════════════════════════════════════ */
.mc-body {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    padding: 32px 24px 40px;
}

/* ══════════════════════════════════════
   PANEL — style fenêtre inventaire MC
══════════════════════════════════════ */
.mc-card {
    width: 100%;
    max-width: 680px;
    /* fond stone */
    background: #c6c6c6;
    /* bordure 3D inventaire Minecraft */
    box-shadow:
        inset -3px -6px 0 #373737,
        inset 3px 3px 0 #ffffff,
        0 0 0 3px #000;
    padding: 20px 22px 24px;
}

.mc-card-icon-row {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 18px;
}

.mc-card-logo {
    width: 36px;
    height: 36px;
    image-rendering: pixelated;
    /* slot inventaire */
    box-shadow: inset -2px -4px 0 #373737, inset 2px 2px 0 #ffffff;
    padding: 2px;
    background: #8b8b8b;
}

.mc-card-title {
    font-family: 'Press Start 2P', monospace;
    font-size: 1rem;
    color: #3f3f3f;
    text-shadow: 1px 1px 0 rgba(255,255,255,0.6);
    margin: 0 0 18px;
    line-height: 1.6;
    letter-spacing: 1px;
}

.mc-card-icon-row .mc-card-title {
    margin-bottom: 0;
}

/* ══════════════════════════════════════
   INFO ROWS
══════════════════════════════════════ */
.mc-info-grid {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.mc-info-row {
    display: flex;
    align-items: center;
    gap: 12px;
    background: #8b8b8b;
    box-shadow: inset -2px -3px 0 #373737, inset 2px 2px 0 #d4d4d4;
    padding: 10px 12px;
}

.mc-info-label {
    font-size: 0.75rem;
    color: #d4d4d4;
    text-shadow: 1px 1px 0 #000;
    text-transform: uppercase;
    letter-spacing: 1px;
    min-width: 150px;
    flex-shrink: 0;
}

.mc-info-value {
    font-size: 0.8rem;
    color: #fff;
    text-shadow: 1px 1px 0 #3f3f3f;
    word-break: break-all;
    line-height: 1.8;
}

.ip-value {
    color: #55ffff;
    text-shadow: 1px 1px 0 #003f3f;
}

.mc-green  { color: #55ff55; text-shadow: 1px 1px 0 #003f00; }
.mc-yellow { color: #ffff55; text-shadow: 1px 1px 0 #3f3f00; }

/* ══════════════════════════════════════
   STEPS
══════════════════════════════════════ */
.mc-note {
    font-size: 0.78rem;
    color: #3f3f3f;
    text-shadow: 1px 1px 0 rgba(255,255,255,0.5);
    margin-bottom: 14px;
    line-height: 2;
}

.mc-steps {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.mc-step {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    background: #8b8b8b;
    box-shadow: inset -2px -3px 0 #373737, inset 2px 2px 0 #d4d4d4;
    padding: 12px 12px;
}

/* slot inventaire pour le numéro */
.mc-slot {
    min-width: 38px;
    height: 38px;
    background: #8b8b8b;
    box-shadow:
        inset -3px -3px 0 #fff,
        inset 3px 3px 0 #373737;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1rem;
    color: #ffff55;
    text-shadow: 2px 2px 0 #3f3f00;
    flex-shrink: 0;
}

.mc-step-text {
    font-size: 0.78rem;
    color: #fff;
    text-shadow: 1px 1px 0 #3f3f3f;
    line-height: 2.2;
}

.mc-ip {
    display: inline-block;
    margin-top: 6px;
    color: #55ffff;
    text-shadow: 1px 1px 0 #003f3f;
    background: #373737;
    padding: 4px 8px;
    font-size: 0.78rem;
}

/* ══════════════════════════════════════
   DISCORD
══════════════════════════════════════ */
.mc-center {
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
}

/* bouton Minecraft classique (bleu Discord) */
.mc-discord-btn {
    display: inline-flex;
    align-items: center;
    margin-top: 16px;
    padding: 14px 28px;
    font-family: 'Press Start 2P', monospace;
    font-size: 0.85rem;
    color: #fff;
    text-decoration: none;
    text-shadow: 2px 2px 0 #2a33a0;
    background: #5865f2;
    box-shadow:
        inset -3px -6px 0 #2a33a0,
        inset 3px 3px 0 #98a0ff,
        0 0 0 3px #000;
    letter-spacing: 0.5px;
    cursor: pointer;
    transition: filter 0.1s;
}

.mc-discord-btn:hover  { filter: brightness(1.15); }
.mc-discord-btn:active {
    box-shadow:
        inset -3px -6px 0 #98a0ff,
        inset 3px 3px 0 #2a33a0,
        0 0 0 3px #000;
}
</style>

